<style scoped>
.pageBox {
  width: 80%;
  margin: 0 auto;
  padding-top: 10px;
}
.pageBox .mainTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;
  height: 70px;
  background: #4fa1a4;
  box-sizing: border-box;
}
.pageBox .mainTitle .left {
  color: #fff;
  font-size: 20px;
}
.pageBox .mainTitle .right {
  width: 84px;
  font-size: 16px;
  color: #323233;
  background: #fff;
  padding: 6px 0;
  cursor: pointer;
}
.pageBox .el-col-12 {
  text-align: left;
  line-height: 32px;
}
.commonTitle {
  color: #323233;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.commonTitle span {
  background: #4fa1a4;
  margin-right: 4px;
}
.firstGrid {
  background: #fff;
  padding: 20px 60px;
}
.firstGrid .label {
  width: 130px;
  margin-right: 30px;
  display: inline-block;
  text-align: right;
}
.secondGrid {
  margin-top: 10px;
  background: #fff;
  padding: 20px 60px 60px 60px;
}
.secondGrid .con {
  padding-left: 30px;
  display: flex;
  align-items: center;
  text-indent: 20px;
}
.secondGrid .lastLine {
  margin-top: 40px;
}
.secondGrid .fileInfo {
  display: flex;
  align-items: center;
  margin-top: 30px;
  padding-left: 30px;
}
.secondGrid .fileInfo img {
  width: 40px;
  height: 40px;
  margin-right: 18px;
}
.secondGrid .fileInfo .fileName {
  color: #bababa;
  margin-right: 53px;
}
.secondGrid .fileInfo .downFile {
  width: 84px;
  font-size: 14px;
  color: #fff !important;
  text-decoration: none !important;
  background: #4fa1a4;
  padding: 6px 0;
  cursor: pointer;
}
</style>
<template>
  <div>
    <div class="pageBox">
      <div class="mainTitle">
        <span class="left">数字化运营委托服务协议</span>
        <span class="right" @click="$router.go(-1)">返回</span>
      </div>
      <div class="firstGrid">
        <p class="commonTitle"><span>&nbsp;</span>合同信息</p>
        <el-row>
          <el-col :span="12">
            <span class="label">公司名称(甲方)：</span>
            <span class="value">{{ contract.tenantName }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">服务商(乙方)：</span>
            <span class="value">{{ contract.serviceName }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">合同开始时间：</span>
            <span class="value">{{ contract.startTime | getDate }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">合同结束时间：</span>
            <span class="value">{{ contract.endTime | getDate }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">合同期限：</span>
            <span class="value">{{ contract.contractYear }}</span>
          </el-col>
        </el-row>
      </div>
      <div class="secondGrid">
        <el-row :gutter="24">
          <el-col :span="12">
            <p class="commonTitle"><span>&nbsp;</span>核心服务内容</p>
            <div class="con">{{ contract.serviceContent }}</div>
          </el-col>
          <el-col :span="12">
            <p class="commonTitle"><span>&nbsp;</span>收费方式</p>
            <div class="con">{{ contract.tollType }}</div>
          </el-col>
          <el-col :span="24" class="lastLine">
            <p class="commonTitle"><span>&nbsp;</span>合同文件</p>
            <div class="fileInfo">
              <img src="../../assets/images/word_icon.png" alt="" />
              <span class="fileName">{{ contractFileName }}</span>
              <a
                :href="contractFileUrl + '?response-content-type=application/octet-stream'"
                style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                download="FileName"
                class="downFile"
                >点击下载</a
              >
              <a
                @click="toSee(contractFileUrl)"
                style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                download="FileName"
                class="downFile"
                >点击查看</a
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contractDetail',
  data() {
    return {
      contract: {},
      contractFileUrl: '',
      contractFileName: '',
    };
  },
  created() {
    if (this.$route.query.contractDetail) {
      this.contract = JSON.parse(this.$route.query.contractDetail);
      this.contractFileUrl = JSON.parse(this.contract.contractFile)[0].url;
      this.contractFileName = JSON.parse(this.contract.contractFile)[0].name;
    }
    console.log('合同', this.contract);
  },
  methods: {

    toSee(url) {
      if(this.contractFileName.indexOf('pdf')>-1){
        window.open(url);
      }else{
        window.open('https://view.officeapps.live.com/op/view.aspx?src='+encodeURIComponent(url));
      }
    
    },
  },
};
</script>